module.exports = __webpack_public_path__ + "src/img/cutIcon.4b891053.svg";